import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface AuthProviderProps {
    children: ReactNode;
}

interface AuthContextType {
    isAuthenticated: boolean;
    login: () => void;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

    useEffect(() => {
        // Check if user is authenticated, e.g., by checking local storage
        const user = localStorage.getItem("access-token");
        setIsAuthenticated(!!user);
    }, []);

    const login = () => {
        // Perform login logic and set isAuthenticated to true
        setIsAuthenticated(true);
    };

    const logout = () => {
        // Perform logout logic and set isAuthenticated to false
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
